import { Chip, Typography } from '@mui/material';
import zeplinColor, { dealStageColors } from 'theme/Color';
const StageChip = ({ dealType }: { dealType: string }) => {
  return (
    <Chip
      label={<Typography variant='responsiveLabel1'>{dealType}</Typography>}
      sx={{
        color: zeplinColor.Neutral1,
        backgroundColor: dealStageColors[dealType.toLowerCase() as keyof typeof dealStageColors],
        borderRadius: '50px',
        height: '22px',
        '& .MuiChip-label': {
          padding: '4px 8px',
        },
      }}
    />
  );
};

export default StageChip;
